import { useEffect, useState } from 'react'

const getUserData = () => {
  return localStorage.getItem('user')
}

export const useUser = () => {
  const [user, setUser] = useState(getUserData())

  useEffect(() => {
    const handleChangeStorage = () => {
      setUser(getUserData())
    }

    window.addEventListener('storage', handleChangeStorage)

    return () => window.removeEventListener('storage', handleChangeStorage)
  }, [])

  return user
}
